import { render, staticRenderFns } from "./Fifth.vue?vue&type=template&id=f5d3ca16&scoped=true"
import script from "./Fifth.vue?vue&type=script&lang=js"
export * from "./Fifth.vue?vue&type=script&lang=js"
import style0 from "./Fifth.vue?vue&type=style&index=0&id=f5d3ca16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d3ca16",
  null
  
)

export default component.exports